// src/axios/cancelToken.js

import axios from 'axios'

let cancelToken

export const getCancelToken = () => {
    if (cancelToken){
        cancelToken.cancel()
    }
    cancelToken = axios.CancelToken.source()
    return cancelToken
}   